import { useURLRedirect } from '@/hooks/useURLRedirect';

/**
 * Composant qui gère automatiquement les redirections 301
 * Place-le dans App.tsx pour qu'il s'exécute sur toutes les pages
 */
export const URLRedirectHandler = () => {
  useURLRedirect();
  return null;
};
